export const COOKIE_LOCATION = 'baldinini_shippinglocation'
export const COOKIE_REGION = 'baldinini_shippingregion'
export const COOKIE_LOCALE = 'baldinini_locale'
export const COOKIE_LANGUAGE = 'baldinini_language'
